export default {
  black: '#000000',
  white: '#FFFFFF',
  grey: '#DCDCDC',
  black2: '#333',
  red: '#FF0000',
}
